(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7607],{

/***/ 75046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4730);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57851);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);


var _excluded = ["children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function Container(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({}, props), {}, {
    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m)('w-[86.667%]', 'max-w-screen-xl', 'mx-auto', className),
    children: children
  }));
}

/***/ }),

/***/ 80819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4730);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57851);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);


var _excluded = ["children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function Wrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({}, props), {}, {
    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m)('py-12', className),
    children: children
  }));
}

/***/ }),

/***/ 81899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoginForm; }
/* harmony export */ });
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faCircleNotch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19961);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82175);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21737);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61903);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83321);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41248);
/* harmony import */ var lib_features_authSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89605);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67814);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);











var validationSchema = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
  email: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_('Enter your email').email('Enter a valid email').required('Email is required'),
  password: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_('Enter your password').required('Password is required')
});
function LoginForm(_ref) {
  var onSuccess = _ref.onSuccess;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      showError = _useState2[0],
      setShowError = _useState2[1];

  var form = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useFormik */ .TA)({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(cred) {
      setLoading(true);
      setShowError(false);
      dispatch((0,lib_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .loginWithEmail */ .fZ)(cred)).unwrap().then(function () {
        setLoading(false);
        onSuccess();
      })["catch"](function () {
        setShowError(true);
        setLoading(false);
      });
    }
  });
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (!router.isReady) return;
    form.setFieldValue('email', router.query.email || '');
  }, [router.isReady]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
    children: [showError && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      severity: 'error',
      className: 'w-full mb-4',
      children: "Incorrect email or password."
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("form", {
      onSubmit: form.handleSubmit,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        fullWidth: true,
        id: "email",
        name: "email",
        label: "Email",
        value: form.values.email,
        onChange: form.handleChange,
        error: form.touched.email && Boolean(form.errors.email),
        helperText: form.touched.email && form.errors.email,
        className: 'mb-4'
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        fullWidth: true,
        id: "password",
        name: "password",
        label: "Password",
        type: "password",
        value: form.values.password,
        onChange: form.handleChange,
        error: form.touched.password && Boolean(form.errors.password),
        helperText: form.touched.password && form.errors.password,
        className: 'mb-4'
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        color: "primary",
        className: '!bg-[#108085]',
        variant: "contained",
        size: 'large',
        fullWidth: true,
        disabled: loading,
        startIcon: loading && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_5__/* .FontAwesomeIcon */ .G, {
          icon: _fortawesome_pro_solid_svg_icons_faCircleNotch__WEBPACK_IMPORTED_MODULE_11__/* .faCircleNotch */ .IJ,
          className: 'animate-spin-fast'
        }),
        type: "submit",
        children: "Login"
      })]
    })]
  });
}

/***/ }),

/***/ 87607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DefaultLayout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(367);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/blocks/Wrapper.js
var Wrapper = __webpack_require__(80819);
// EXTERNAL MODULE: ./components/blocks/Container.js
var Container = __webpack_require__(75046);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(3580);
// EXTERNAL MODULE: ./components/blocks/Header/index.module.scss
var index_module = __webpack_require__(92802);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./assets/logo-new.png
var logo_new = __webpack_require__(49505);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUser.js
var faUser = __webpack_require__(36351);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 3 modules
var Menu = __webpack_require__(44347);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(30431);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(98456);
// EXTERNAL MODULE: ./components/forms/LoginForm.js
var LoginForm = __webpack_require__(81899);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./lib/features/authSlice.js
var authSlice = __webpack_require__(89605);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/blocks/Header/UserMenu.js



















function UserMenu(_ref) {
  var t = _ref.t;
  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      menuAnchor = _React$useState2[0],
      setMenuAnchor = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      loginModalOpen = _React$useState4[0],
      setLoginModalOpen = _React$useState4[1];

  var user = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.user;
  });
  var menuRef = /*#__PURE__*/(0,react.createRef)();
  var menuOpen = Boolean(menuAnchor);

  var openUserMenu = function openUserMenu(event) {
    setMenuAnchor(event.currentTarget);
  };

  var closeUserMenu = function closeUserMenu() {
    setMenuAnchor(null);
  };

  var handleLogin = function handleLogin() {
    closeUserMenu();
    router.pathname !== '/login' && setLoginModalOpen(true);
  };

  var closeLoginModal = function closeLoginModal() {
    setLoginModalOpen(false);
  };

  var handleLogout = function handleLogout() {
    closeUserMenu();
    menuRef.current.addEventListener('transitionend', function () {
      dispatch((0,authSlice/* logout */.kS)());
    }, {
      once: true
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [!!user && (0,helper.isValidEmail)(user.email) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
      className: (0,clsx_m/* default */.Z)((index_module_default()).action, (index_module_default()).user),
      onClick: openUserMenu,
      "aria-controls": menuOpen ? 'auth-menu' : undefined,
      "aria-haspopup": "true",
      "aria-expanded": menuOpen ? 'true' : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
        icon: faUser/* faUser */.IL
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
      className: (0,clsx_m/* default */.Z)((index_module_default()).action, (index_module_default()).user),
      onClick: openUserMenu,
      "aria-controls": menuOpen ? 'auth-menu' : undefined,
      "aria-haspopup": "true",
      "aria-expanded": menuOpen ? 'true' : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
        className: "w-25 font-normal text-base",
        children: t('home:notLoggedIn')
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Menu/* default */.Z, {
      id: "auth-menu",
      ref: menuRef,
      anchorEl: menuAnchor,
      open: menuOpen,
      onClose: closeUserMenu,
      MenuListProps: {
        'aria-labelledby': 'basic-button'
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      children: [!user || !(0,helper.isValidEmail)(user.email) ? [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
        onClick: handleLogin,
        className: 'hover:text-primary',
        children: "Log in"
      }, 'login'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}, 'd-1'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: '/sign-up',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
          onClick: closeUserMenu,
          className: 'hover:text-primary',
          children: "Sign up"
        })
      }, 'sign-up')] : [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem/* default */.Z, {
        disabled: true,
        children: ["Logged in as ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), user.email]
      }, 'user-info'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}, 'd-1'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: '/change-password',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
          onClick: closeUserMenu,
          className: 'hover:text-primary',
          children: "Change password"
        })
      }, 'change-password'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
        onClick: handleLogout,
        className: 'hover:text-primary',
        children: "Log out"
      }, 'logout')], !!user && !!(0,helper.isValidEmail)(user.email) ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}, 'd-1'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          rel: "noreferrer",
          href: 'https://admin.damamaps.com/dashboard/business-account',
          target: "_blank",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
            onClick: closeUserMenu,
            className: 'hover:text-primary',
            children: "Manage my store"
          })
        }, 'change-password')]
      }) : null]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* default */.Z, {
      open: loginModalOpen,
      onClose: closeLoginModal,
      className: 'flex p-6',
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "bg-white m-auto shadow-lg p-8 rounded max-w-sm",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
          className: 'text-3xl font-bold text-center mb-8',
          children: "Log in"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginForm/* default */.Z, {
          onSuccess: closeLoginModal
        })]
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 2 modules
var OutlinedInput = __webpack_require__(37058);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var icons_material_Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(10155);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./lib/services/product.js
var product = __webpack_require__(1549);
// EXTERNAL MODULE: ./lib/store.js + 1 modules
var store = __webpack_require__(18820);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/mui-nested-menu/module.js + 1 modules
var mui_nested_menu_module = __webpack_require__(22083);
;// CONCATENATED MODULE: ./components/NavMenu.js













function NavMenu(props) {
  var menuName = props.menuName,
      menuList = props.menuList,
      routeInfo = props.routeInfo,
      t = props.t,
      clickAction = props.clickAction,
      isMobile = props.isMobile;

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _useState = (0,react.useState)([]),
      localList = _useState[0],
      setLocalList = _useState[1];

  var router = (0,next_router.useRouter)();
  var open = Boolean(anchorEl);

  var handleClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(parentRouteInfo, routeName) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleClose();
              _context.next = 3;
              return clickAction(parentRouteInfo, routeName);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleHover = function handleHover(e, name) {
    if (name === menuName) {
      setAnchorEl(e.currentTarget);
    }
  };

  var handleLeave = function handleLeave(e, name) {
    if (name === menuName) {
      setAnchorEl(null);
    }
  };

  (0,react.useEffect)(function () {
    console.log('at menu: ', routeInfo.href, isMobile);

    var temp = (0,toConsumableArray/* default */.Z)(menuList);

    var all = temp.find(function (item) {
      return item.name === t('home:allCategories');
    });
    var hasAll = all !== undefined;

    if (!hasAll) {
      temp.push({
        name: t('home:allCategories'),
        url: '',
        slug: ''
      });
    }

    setLocalList(temp);
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: isMobile ? (0,clsx_m/* default */.Z)('font-bold', 'last:mr-0', 'leading-10', 'uppercase', {
      'text-primary-dark': router.pathname === routeInfo.href
    }) : (0,clsx_m/* default */.Z)('font-bold', 'mr-7', 'last:mr-0', 'leading-10', 'uppercase', {
      'text-primary-dark': router.pathname === routeInfo.href
    }),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      className: (0,clsx_m/* default */.Z)('font-bold', 'mr-7', 'last:mr-0', 'leading-10', 'uppercase'),
      onClick: function onClick(e) {
        return isMobile ? handleHover(e, routeInfo.label) : null;
      },
      onMouseOver: function onMouseOver(e) {
        return isMobile ? null : handleHover(e, routeInfo.label);
      },
      children: menuName
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu/* default */.Z, {
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      MenuListProps: {
        'aria-labelledby': 'basic-button',
        onMouseLeave: function onMouseLeave(e) {
          return handleLeave(e, routeInfo.label);
        }
      },
      className: 'mt-5',
      children: localList.map(function (item, index) {
        if (item.subcategories && item.subcategories.length > 0) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mui_nested_menu_module/* NestedMenuItem */.Ub, {
            label: t("home:".concat(item.slug)),
            parentMenuOpen: open,
            onClick: function onClick() {
              return isMobile ? null : handleClick(routeInfo, item.slug);
            },
            className: (0,clsx_m/* default */.Z)('mr-7', 'last:mr-0', 'leading-10'),
            children: !!item.subcategories && item.subcategories.length > 0 && item.subcategories.map(function (nestedItem) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                onClick: function onClick() {
                  return handleClick(routeInfo, nestedItem.slug);
                },
                className: (0,clsx_m/* default */.Z)('last:mr-0', 'leading-10'),
                children: t("home:".concat(nestedItem.slug))
              }, nestedItem.name);
            })
          }, item.name);
        } else {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
            onClick: function onClick() {
              return handleClick(routeInfo, item.slug);
            },
            className: (0,clsx_m/* default */.Z)('mr-7', 'last:mr-0', 'leading-10'),
            children: item.name === t('home:allCategories') ? t('home:allCategories') : t("home:".concat(item.slug))
          }, item.name);
        }
      })
    })]
  });
}
// EXTERNAL MODULE: ./data/config.json
var config = __webpack_require__(56513);
;// CONCATENATED MODULE: ./components/blocks/Header/index.js




































function Header(props) {
  var categories = props.categories;
  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      menuAnchor = _React$useState2[0],
      setMenuAnchor = _React$useState2[1];

  var menuRef = /*#__PURE__*/(0,react.createRef)();
  var menuOpen = Boolean(menuAnchor);

  var openLangMenu = function openLangMenu(event) {
    setMenuAnchor(event.currentTarget);
  };

  var closeLangMenu = function closeLangMenu() {
    setMenuAnchor(null);
  };

  var changeLang = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var pathname, asPath, query;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('t: ', i18n.language, router.pathname);
              pathname = router.pathname, asPath = router.asPath, query = router.query;
              _context.next = 4;
              return router.push({
                pathname: pathname,
                query: query
              }, asPath, {
                locale: i18n.language === 'en' ? 'cn' : 'en'
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function changeLang() {
      return _ref.apply(this, arguments);
    };
  }();

  var ROUTES = [{
    href: '/',
    label: t('home:Home')
  }, {
    href: '/products',
    label: t('home:Products')
  }, // , {
  //   href: '/#',
  //   label: t('home:Strains'),
  // },
  {
    href: '/brands/discovery',
    label: t('home:Brands')
  }, {
    href: '/services',
    label: t('home:Services')
  }, {
    href: '/map',
    label: t('home:Map')
  } // {
  //   href: '/deals',
  //   label: t('home:Deals'),
  // }
  ];

  var _useState = (0,react.useState)(''),
      searchInput = _useState[0],
      setSearchInput = _useState[1];

  var handleChangeSearchInput = function handleChangeSearchInput(e) {
    setSearchInput(e.target.value);
  };

  var handleSearch = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(e) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return router.push("/search/".concat(searchInput));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSearch(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var goToHome = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(e) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return router.push("/");

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function goToHome(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var goTo = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(parentRoute, routeName) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              console.log('routerName: ', routeName);

              if (!(routeName === t('home:allCategories'))) {
                _context4.next = 6;
                break;
              }

              _context4.next = 4;
              return router.replace("".concat(parentRoute.href));

            case 4:
              _context4.next = 8;
              break;

            case 6:
              _context4.next = 8;
              return router.replace("".concat(parentRoute.href, "/").concat(routeName.toLowerCase()));

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function goTo(_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var goToBag = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(e) {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return router.push("/shoppingBag");

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function goToBag(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();

  var _useState2 = (0,react.useState)(false),
      mobileOpen = _useState2[0],
      setMobileOpen = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loaded = _useState3[0],
      setLoaded = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  (0,react.useEffect)(function () {
    setLoaded(true);
  }, []);
  (0,react.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,helper.checkMobile)());
    }
  }, [loaded]);

  var handleDrawerToggle = function handleDrawerToggle() {
    setMobileOpen(function (prevState) {
      return !prevState;
    });
  };

  var drawerWidth = 240;

  var drawer = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
    sx: {
      textAlign: 'center'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "mx-5 my-2",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        className: (index_module_default()).logo,
        src: logo_new["default"],
        alt: "Logo",
        onClick: goToHome
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(List/* default */.Z, {
      children: [ROUTES.map(function (route) {
        return route.label === t('home:Products') ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavMenu, {
          isMobile: isMobile,
          clickAction: goTo,
          t: t,
          routeInfo: route,
          menuName: t('home:Products'),
          menuList: config/* product.categories */.O7.bd
        }, route.label) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem/* default */.ZP, {
          disablePadding: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemButton/* default */.Z, {
            className: "flex justify-center",
            sx: {
              textAlign: 'center'
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
              href: route.href,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                className: (0,clsx_m/* default */.Z)('font-bold', 'mr-7', 'last:mr-0', 'leading-10', 'uppercase', {
                  'text-primary-dark': router.pathname === route.href
                }),
                children: route.label
              })
            }, route.label)
          })
        }, route.label);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemButton/* default */.Z, {
          className: (0,clsx_m/* default */.Z)('w-10', 'flex', 'justify-center'),
          onClick: changeLang,
          "aria-controls": menuOpen ? 'lang-menu' : undefined,
          "aria-haspopup": "true",
          "aria-expanded": menuOpen ? 'true' : undefined,
          children: i18n.language === 'en' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: (0,clsx_m/* default */.Z)('font-bold', 'mr-7', 'last:mr-0', 'leading-10', 'uppercase'),
            children: '中文'
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: (0,clsx_m/* default */.Z)('font-bold', 'mr-7', 'last:mr-0', 'leading-10', 'uppercase'),
            children: 'EN'
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControl/* default */.Z, {
          fullWidth: true,
          size: 'small',
          className: 'mt-1 w-auto',
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlinedInput/* default */.Z, {
            placeholder: t('home:searchThisMenu'),
            id: 'menu-search',
            onChange: handleChangeSearchInput,
            onKeyDown: function onKeyDown(ev) {
              if (ev.key === 'Enter') {
                // Do code here
                handleSearch();
                ev.preventDefault();
              }
            },
            endAdornment: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
              className: 'cursor-pointer',
              icon: faSearch/* faSearch */.wn,
              onClick: handleSearch
            })
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem/* default */.ZP, {})]
    })]
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("header", {
    className: (0,clsx_m/* default */.Z)((index_module_default()).header, 'sticky', 'top-0', 'bg-white', 'z-40'),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      className: "shadow-md py-4",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((index_module_default()).container, 'flex', 'items-center', 'flex-nowrap'),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: (0,clsx_m/* default */.Z)((index_module_default()).logo, 'mr-7', 'shrink-0'),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
            className: (index_module_default()).logo,
            src: logo_new["default"],
            alt: "Logo",
            onClick: goToHome
          })
        }), isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: "flex w-full justify-end",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserMenu, {
            t: t
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toolbar/* default */.Z, {
            className: "flex flex-row align-center self-center  pr-0",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
              color: "inherit",
              "aria-label": "open drawer",
              edge: "start",
              onClick: handleDrawerToggle,
              sx: {
                display: {
                  sm: 'none'
                }
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_material_Menu/* default */.Z, {})
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
            component: "nav",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer/* default */.ZP // container={container}
            , {
              variant: "temporary",
              open: mobileOpen,
              onClose: handleDrawerToggle,
              ModalProps: {
                keepMounted: true // Better open performance on mobile.

              },
              sx: {
                display: {
                  xs: 'block',
                  sm: 'none'
                },
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: drawerWidth
                }
              },
              children: drawer
            })
          })]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
            className: (0,clsx_m/* default */.Z)('flex', 'grow', 'shrink', 'min-w-0', 'overflow-hidden'),
            children: ROUTES.map(function (route) {
              return route.label === t('home:Products') ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavMenu, {
                isMobile: isMobile,
                clickAction: goTo,
                t: t,
                routeInfo: route,
                menuName: t('home:Products'),
                menuList: config/* product.categories */.O7.bd
              }, route.label) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: route.href,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  className: (0,clsx_m/* default */.Z)('font-bold', 'mr-7', 'last:mr-0', 'leading-10', 'uppercase', {
                    'text-primary-dark': router.pathname === route.href
                  }),
                  children: route.label
                })
              }, route.label);
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControl/* default */.Z, {
            fullWidth: true,
            size: 'small',
            className: 'mt-1 w-auto',
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlinedInput/* default */.Z, {
              placeholder: t('home:searchThisMenu'),
              id: 'menu-search',
              onChange: handleChangeSearchInput,
              onKeyDown: /*#__PURE__*/function () {
                var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(ev) {
                  return regenerator_default().wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          if (!(ev.key === 'Enter')) {
                            _context6.next = 4;
                            break;
                          }

                          _context6.next = 3;
                          return handleSearch();

                        case 3:
                          ev.preventDefault();

                        case 4:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }(),
              endAdornment: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                className: 'cursor-pointer',
                icon: faSearch/* faSearch */.wn,
                onClick: handleSearch
              })
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
            className: (0,clsx_m/* default */.Z)((index_module_default()).action, 'w-10', 'flex'),
            onClick: changeLang,
            "aria-controls": menuOpen ? 'lang-menu' : undefined,
            "aria-haspopup": "true",
            "aria-expanded": menuOpen ? 'true' : undefined,
            children: i18n.language === 'en' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: '中文'
            }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: 'EN'
            }) // <Image src={enIcon} alt={'English'} className={'object-cover h-full'} /> :
            // <Image src={cnIcon} alt={'Chinese'} className={'object-cover h-full'} />

          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserMenu, {
            t: t
          })]
        })]
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
var objectDestructuringEmpty = __webpack_require__(77191);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
;// CONCATENATED MODULE: ./components/blocks/Footer.js



var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var Column = function Column(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: 'w-1/3',
    children: children
  });
};

var SocialLink = function SocialLink(_ref2) {
  var href = _ref2.href,
      icon = _ref2.icon;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
    href: href,
    target: "_blank",
    rel: "noreferrer",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
      variant: "text",
      className: "text-black hover:text-primary",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
        icon: icon,
        className: "w-[1em] text-base"
      })
    })
  });
};

var LinkGroup = function LinkGroup(_ref3) {
  var title = _ref3.title,
      children = _ref3.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: "flex flex-col gap-1 items-start mb-4 last:mb-0",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
      className: "mb-2 font-semibold",
      children: title
    }), children]
  });
};

var FooterLink = function FooterLink(_ref4) {
  var children = _ref4.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), _objectSpread(_objectSpread({}, props), {}, {
    passHref: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      className: "text-gray-500",
      target: "_blank",
      children: children
    })
  }));
};

function Footer(_ref5) {
  (0,objectDestructuringEmpty/* default */.Z)(_ref5);

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useState = (0,react.useState)(false),
      loaded = _useState[0],
      setLoaded = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0,react.useEffect)(function () {
    setLoaded(true);
  }, []);
  (0,react.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,helper.checkMobile)());
    }
  }, [loaded]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      className: 'border-t',
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("footer", {
          className: isMobile ? 'flex flex-col lg:flex-row items-center' : 'flex flex-col lg:flex-row',
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: 'w-64 shrink min-w-[200px] text-center',
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "mb-4",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                src: __webpack_require__(49505),
                alt: 'DaMaWish'
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
              className: "w-full text-[#7c7c7c] mb-4 pl-1",
              viewBox: "0 0 142 13",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                x: "0",
                y: "10",
                className: i18n.language === 'en' ? "text-[10px] font-semibold" : "text-[9px] font-semibold",
                fill: "currentColor",
                children: t('home:footer_slogan')
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: "flex justify-between px-3",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, {
                href: "https://www.facebook.com/damawish",
                icon: free_brands_svg_icons/* faFacebookF */.AYu
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, {
                href: "https://www.instagram.com/damawishcom/?hl=en",
                icon: free_brands_svg_icons/* faInstagram */.Zzi
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, {
                href: "https://x.com/damawish?s=21&t=qVtyVJwVZj7d6zG4XFbEDQ",
                icon: free_brands_svg_icons/* faTwitter */.mdU
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLink, {
                href: "https://www.linkedin.com/company/damawish/",
                icon: free_brands_svg_icons/* faLinkedinIn */.hwn
              })]
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "grow basis-10 shrink-0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: isMobile ? "grow flex gap-2 basis-[100px] shrink" : "grow flex gap-2 basis-[700px] shrink",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkGroup, {
                title: t('home:footer_about'),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/about-us",
                  children: t('home:footer_about_us')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/business-solutions",
                  children: t('home:footer_about_help_center')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/partner-relations",
                  children: t('home:footer_about_investor_relations')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/cat/strains",
                  children: t('home:footer_about_strain_database')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://www.linkedin.com/company/damawish",
                  children: t('home:footer_about_career')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/help",
                  children: t('home:footer_about_contact')
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkGroup, {
                title: t('home:footer_business_solution'),
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://admin.damamaps.com",
                  children: t('home:footer_list_your_cannabiz')
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkGroup, {
                title: t('home:footer_legal'),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/terms-of-use-and-privacy/",
                  children: t('home:footer_terms_of_use')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/terms-of-use-and-privacy/",
                  children: t('home:footer_privacy_policy')
                })]
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkGroup, {
                title: t('home:footer_discover'),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "/map",
                  children: t('home:footer_discover_dispensary')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "/map",
                  children: t('home:footer_doctors')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/news",
                  children: t('home:footer_news')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/bbs",
                  children: t('home:footer_social_netowrking')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "https://damamap.com/law",
                  children: t('home:footer_learningcenter')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "/sign-up",
                  children: t('home:sign_up')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                  href: "/login",
                  children: t('home:log_in')
                })]
              })
            })]
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      className: 'border-t py-4',
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        className: 'text-center text-sm',
        children: t('home:copyRight')
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./components/AgeVerification.js








function AgeVerification() {
  var _useState = (0,react.useState)(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      isValidAge = _useState3[0],
      setIsValidAge = _useState3[1];

  var user = (0,es/* useSelector */.v9)(function (state) {
    return state.auth.user;
  });

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  (0,react.useEffect)(function () {
    var ageChecked = JSON.parse(localStorage.getItem('ageChecked'));
    setOpen(!Boolean(ageChecked));
    setLoading(false);
  }, []);
  (0,react.useEffect)(function () {
    if (user !== null && user !== void 0 && user.isLoggedIn) {
      handleYes();
    }
  }, [user]);

  var handleYes = function handleYes() {
    localStorage.setItem('ageChecked', 'true');
    setOpen(false);
  };

  var handleNo = function handleNo() {
    setIsValidAge(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [loading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "fixed z-[1299] bg-gray-100 inset-0"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* default */.Z, {
      open: open,
      onClose: function onClose(e) {
        return e.preventDefault();
      },
      className: 'flex p-6',
      componentsProps: {
        backdrop: {
          className: "bg-gray-100"
        }
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "bg-white m-auto shadow-lg p-8 rounded max-w-md outline-0 w-full flex flex-col items-center text-center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: "max-w-[250px] mb-6",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
            src: __webpack_require__(49505),
            alt: "DaMaMaps"
          })
        }), isValidAge ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "text-3xl font-semibold mb-4",
            children: t('home:areYouOldEnough')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "text-gray-500 mb-10",
            children: t('home:ageVerificationNote')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex w-full gap-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              variant: "outlined",
              fullWidth: true,
              onClick: handleNo,
              children: t('home:notOldEnough')
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              className: '!bg-[#108085]',
              variant: "contained",
              fullWidth: true,
              onClick: handleYes,
              children: t('home:oldEnough')
            })]
          })]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "text-3xl font-semibold mb-4",
            children: t('notOldEnoughRespond')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "text-gray-500",
            children: t('notOldEnoughRespond2')
          })]
        })]
      })
    })]
  });
}
;// CONCATENATED MODULE: ./layouts/Default.js






function DefaultLayout(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AgeVerification, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {}), children, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {})]
  });
}

/***/ }),

/***/ 49505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/logo-new.f480017c.png","height":781,"width":2500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAvcEAwMMAwcFiz9NBt7o7uLps0NMmfjSYAAAAB3RSTlM4SlXApI3lZqmDlwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGVmYGBiYGJkYGFjYGRkYGQAAAEmABvKId+WAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 92802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__vJ1Tx","action":"Header_action__xj4Uv"};

/***/ })

}]);